import React, { memo } from "react";
import "./football.m.css";

function FootballCta({text}) {
  return (
    <a styleName="football-cta-widget" href="/fifa-world-cup-2026-live-score">
      <span styleName="cta-icon">⚽</span>
      <span styleName="cta-text">{text.toUpperCase()}</span>
      <span styleName="cta-live">
        <svg styleName="live-dot" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
          <circle cx="4" cy="4" r="4" fill="#006219"/>
        </svg>
        Live
      </span>
    </a>
  );
}

export default memo(FootballCta);
